import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {NoosFormTypeService} from '../../class/NoosFormTypeService';
import {
    EventName,
    IActionPassData,
    IFormCustomeButton,
    IFormFileItem,
    IFormSaveEmit,
    IFormSaveStructure,
    IFormSavingData,
    IFormStructure,
    ITriggers
} from '../../interface/form-structure';
import {IViewComponent, IViewStepperComponent} from '../../interface/panels';
import {IAPIURLs, IGetDataReturn, IHttpSetting} from '../../interface/dataset-params';
import {GlobalObjectService} from '../../class/global-obj';
import {ActionFlag, IFormDialogData, IWizardViewOutput} from '../../interface/component';
import {HttpFormService} from '../../services/formServices';
import {FormSaver, IFormValidationError} from '../../class/FormValidation';
import {DialogFormErrorComponent} from '../Dialogs/dialog-form-error/dialog-form-error.component';
import {HttpFormDataService} from '../../services/services';
import {FormLoader} from '../../class/formLoader';
import {IFieldShema} from '@usteknoloji/noosgrid';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {FormEventService, IEventData} from '../../services/formEventService';
import {Subscription} from 'rxjs';
import {BroadcastMessageService, EventType, IGlobalEventData} from '@usteknoloji/noos-brodcast-messaging';
import {LocalDbService} from '../../class/localdb';

@Component({
    selector: 'noos-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})

@NoosFormTypeService.register('noosform2')
export class FormComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    @ViewChild('container', {read: ViewContainerRef, static: true}) formContainer: ViewContainerRef;

    @Input()
    inData: IFormDialogData;

    @Input()
    formJson: IFormStructure;

    @Input()
    setting: IHttpSetting;

    @Input()
    API_URLS: IAPIURLs;

    @Input()
    actionFlag: ActionFlag = ActionFlag.NEW;

    @Input()
    workFlowObjectId: any;

    @Input()
    isDialog = false;

    @Input()
    isFilter = false;

    @Input()
    isTest = false; // form test ediliyor. Submit edilmes

    @Input()
    isView = false;

    @Input()
    outData = undefined; // dışarıdan özgün data almak için

    @Input()
    btnText = 'Kaydet';

    @Input()
    FORM_ID = 0;

    @Input()
    RECORD_ID = 0;

    @Output()
    saveForm = new EventEmitter<IFormSaveEmit>();

    @Input()
    showOnlyRecordMe = false;

    @Input()
    trackRecorder = false;

    @Input()
    actionPassedData: IActionPassData = null;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    titlePass: EventEmitter<string> = new EventEmitter<string>();

    @Output()
    itFormLoaded$: EventEmitter<any> = new EventEmitter<any>();

    fileData: IFormFileItem[] = [];
    masterDatasetId: any = 0;
    FORM_GUID: any = 0;

    showButtonSave = true;
    showButtonNext = false;
    showButtonPrev = false;

    currentFormInstance: any;
    formIsLoading = true;
    loadingIsDone = false;
    error: any;
    fileControlResult = true;
    isSaving = false;

    triggerSave = false;
    justRecordMe = false;

    formFieldStructure: IFieldShema[];
    formRecordData: any;

    subscription: Subscription;
    subscription2: Subscription;
    globalSubscription: Subscription;
    globalSubscription2: Subscription;

    customButtons: IFormCustomeButton[] = [];
    liveValue = false;

    showLoader = true;

    runSetUpData = false;


    getID() {
        return Math.random().toString(36).substr(2, 9) + '--' +
            Math.random().toString(36).substr(2, 9);
    }

    constructor(
        public dialogRef: MatDialogRef<FormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        private componentFactoryResolver: ComponentFactoryResolver,
        private noosFormTypeFactory: NoosFormTypeService,
        private dialog: MatDialog,
        private formService: HttpFormService,
        private datasetService: HttpFormDataService,
        private cd: ChangeDetectorRef,
        private eventListenerService: FormEventService,
        private globalEventListenerService: BroadcastMessageService,
        private localdb: LocalDbService
    ) {

        this.FORM_GUID = this.getID();

        if (this.data && this.data.formId) {


            this.formJson = this.data.formJson;
            this.setting = this.data.setting;
            this.API_URLS = this.data.API_URLS;
            this.actionFlag = this.data.actionFlag;
            this.workFlowObjectId = this.data.workFlowObjectId;
            this.FORM_ID = this.data.formId;
            this.RECORD_ID = this.data.recordId;
            this.isDialog = true;
            this.actionPassedData = this.data.actionPassedData;
            this.isTest = this.data.isTest || false;
            this.outData = this.data.outData || undefined;
            GlobalObjectService.register('outData_' + this.FORM_ID.toString(), this.outData, true);

        }


    }

    public setUpData(inData, showLoader = true, name = '') {

        if (!this.runSetUpData) {

            console.log('FORM2->IN-->setUpData-->' + name);
            this.inData = inData;
            this.formJson = this.inData.formJson;
            this.setting = this.inData.setting;
            this.API_URLS = this.inData.API_URLS;
            this.actionFlag = this.inData.actionFlag;
            this.workFlowObjectId = this.inData.workFlowObjectId;
            this.FORM_ID = this.inData.formId;
            this.RECORD_ID = this.inData.recordId;
            this.actionPassedData = this.inData.actionPassedData;
            this._createUpForm();
            this.isView = true;
            this.showButtonPrev = false;
            this.showButtonNext = false;
            this.isDialog = false;
            this.liveValue = this.inData.liveValue || false;
            this.showLoader = showLoader;

            this.runSetUpData = true;
        }
    }

    ngAfterViewInit(): void {

        console.log('FORM2->IN-->ngAfterViewInit');

        this._createUpForm();
        this.globalSubscription = this.globalEventListenerService.event.subscribe((eventData: IGlobalEventData) => {
            // console.log('GLOBAL', eventData);
            /*
            if (eventData !== null && eventData.triggerType === EventType.UPDATE) {
                this.loadRecord(false);
            }
             */
        });

        /* this.globalSubscription2 = this.globalEventListenerService.eventLive.subscribe(ed=>{
             console.log('GLOBAL LIVE2----', ed);
         });*/

        this.subscription = this.eventListenerService.event.subscribe((eventData) => {
            console.log('---- FORM2 --> EventData:', eventData);
            if (this.formJson !== null && eventData !== null && eventData !== undefined) {
                if (eventData.eventName !== null && eventData.eventName === 'add'
                    && this.formJson.form_json.form_json[0].option.dataset_id === eventData.datasetId) {
                    this.eventListenerService.updateLiveView(true);
                }
            }

            if (eventData !== undefined && eventData !== null && eventData.formId === this.FORM_ID
                && this.formJson !== null && this.formJson !== undefined) {

                if (eventData.eventName === 'select_row') {
                    this._eventSelectRow(eventData);
                } else if (eventData.eventName === 'set_form_id') {
                    this._eventSetFormId(eventData);
                } else if (eventData.eventName === 'select') {
                    this._eventonTrigger(EventName.ComponentSelect, eventData);
                } else if (eventData.eventName === 'select_address') {
                    console.log('select address:', eventData);
                    this.__setFormValue(eventData.datasetId, 'address', eventData.triggerValue);
                }

            }
        });

        this.subscription2 = this.eventListenerService.live.subscribe((eventData) => {
            if (eventData && this.liveValue) {
                // console.log('----LIVE', eventData);
                // this.loadRecord();
            }
        });

    }


    private __setFormValue(datasetId, keyName: string, keyValue: any) {
        this.formJson.form_json.form_json.forEach(form => {
            if ((datasetId === null || datasetId === undefined || datasetId === 0)
                || (datasetId !== null && datasetId !== undefined && datasetId > 0 && form.option.dataset_id === datasetId)) {
                form.rows.forEach(row => {
                    row.cols.forEach(col => {
                        const controlFind = col.controls.filter(c => c.name === keyName);
                        if (controlFind.length > 0) {
                            controlFind[0].defaultValue = keyValue;
                            this.cd.detectChanges();
                        }
                    });
                });
            }
        });
    }

    private __setControlProp(datasetId, controlName: string, propName: any, propValue: any) {
        this.formJson.form_json.form_json.forEach(form => {
            if ((datasetId === null || datasetId === undefined || datasetId === 0)
                || (datasetId !== null && datasetId !== undefined && datasetId > 0 && form.option.dataset_id === datasetId)) {
                form.rows.forEach(row => {
                    row.cols.forEach(col => {
                        const controlFind = col.controls.filter(c => c.name === controlName);
                        if (controlFind.length > 0) {
                            controlFind[0][propName] = propValue;
                        }
                    });
                });
            }
        });
    }

    private __executeResponseData(response: IGetDataReturn) {
        if (response.transfer_data !== null && response.transfer_data !== undefined && response.transfer_data.length > 0) {
            response.transfer_data.forEach(td => {
                if (td.fields !== undefined && td.fields !== null && td.fields.length > 0) {
                    td.fields.forEach(item => {
                        const result = Object.keys(item).map(key => ({key, value: item[key]}));
                        result.forEach(r => {
                            this.__setFormValue(td.dataset_id, r.key, r.value);
                        });
                    });
                }
            });
        }
    }

    private __call(param: ITriggers, eventData: IEventData | undefined) {


        const saver = new FormSaver(this.formJson, this.workFlowObjectId, this.fileControlResult, this.actionPassedData);
        const formData: IFormSavingData = saver.generateSubmitData();
        const postData: IFormSaveStructure = {
            data: formData,
            FORM_ID: this.FORM_ID,
            RECORD_ID: this.RECORD_ID,
            FORM_GUID: this.FORM_GUID,
            masterDatasetId: this.masterDatasetId,
            flag: undefined,
            rid: this.RECORD_ID || 0
        };

        this.isSaving = true;
        this.formService.callCR(this.FORM_ID, postData, param.functionId).subscribe(ret => {
            this.isSaving = false;
            if (ret.complete) {
                this.__executeResponseData(ret);

                if (ret.error_message !== '') {
                    alert(ret.error_message);
                }

                if (ret.trigger_form && ret.trigger_form_id !== undefined && ret.trigger_form_id !== 0) {
                    // Yeni bir form açılacak

                    const dialogData: IFormDialogData = {
                        setting: this.setting,
                        formId: ret.trigger_form_id,
                        formJson: null,
                        actionFlag: ret.trigger_record === undefined || ret.trigger_record === 0 ? ActionFlag.NEW : ActionFlag.EDIT,
                        API_URLS: null,
                        workFlowObjectId: '',
                        actionPassedData: this.actionPassedData,
                        recordId: ret.trigger_record,
                        triggerData: ret.transfer_data
                    };
                    this.openNewForm(dialogData);
                }
            }
        }, error1 => {
            this.isSaving = false;
        });

    }

    private __disableFalse(param: ITriggers, eventData: IEventData | undefined) {
        let defaultSet = true;
        if (param.whereValue !== undefined && param.whereValue !== '' && eventData !== undefined) {
            defaultSet = param.whereValue === eventData.triggerValue;

        }
        if (defaultSet) {
            this.__setControlProp(param.dataset_id, param.toName, 'disabled', false);
            this.cd.detectChanges();
        }
    }

    private __disableTrue(param: ITriggers, eventData: IEventData | undefined) {
        let defaultSet = true;
        if (param.whereValue !== undefined && param.whereValue !== '' && eventData !== undefined) {
            defaultSet = param.whereValue === eventData.triggerValue;
        }
        if (defaultSet) {
            this.__setControlProp(param.dataset_id, param.toName, 'disabled', true);
            this.cd.detectChanges();
        }

    }

    private __hiddenTrue(param: ITriggers, eventData: IEventData | undefined) {

        let defaultSet = true;
        if (param.whereValue !== undefined && param.whereValue !== '' && eventData !== undefined) {
            defaultSet = param.whereValue.toString() === eventData.triggerValue;
        }
        if (defaultSet) {
            this.formJson.form_json.form_json.forEach(ff => {
                const controlName = 'Form:' + ff.header.title;
                if (param.toNameTitle === controlName) {
                    ff.isVisible = true;
                    console.log('-->', controlName, 'True');
                }
            });
        }

    }

    private __hiddenFalse(param: ITriggers, eventData: IEventData | undefined) {
        let defaultSet = true;
        if (param.whereValue !== undefined && param.whereValue !== '' && eventData !== undefined) {
            defaultSet = param.whereValue.toString() === eventData.triggerValue;
        }
        if (defaultSet) {
            this.formJson.form_json.form_json.forEach(ff => {
                const controlName = 'Form:' + ff.header.title;
                if (param.toNameTitle === controlName) {
                    ff.isVisible = false;
                    console.log('-->', controlName, 'False');
                }
            });
        }

    }

    private __set(param: ITriggers, eventData: IEventData | undefined) {
        let defaultSet = true;
        if (param.whereValue !== '' && eventData !== undefined) {
            defaultSet = param.whereValue === eventData.triggerValue;
        }
        if (defaultSet) {
            this.__setFormValue(param.dataset_id, param.toName, param.setValue);
        }
    }

    private __formLoad(param: ITriggers, eventData: IEventData | undefined) {

    }

    private __completeTriggers(datasetId, triggers: ITriggers[], eventData: IEventData | undefined) {
        if (triggers !== null && triggers !== undefined && triggers.length > 0) {
            triggers.forEach(t => {
                const methodName = '__' + t.triggerName;
                if (this[methodName]) {
                    this[methodName](t, eventData);
                }
            });
            this.cd.detectChanges();
        }

    }

    private _eventonTrigger(eventName: EventName, eventData?: IEventData | undefined) {
        // Form Create edildikten sonra çalışacak event
        if (this.formJson.form_json.events !== undefined && this.formJson.form_json.events.length > 0) {
            if (this.masterDatasetId !== null && this.masterDatasetId !== undefined && this.masterDatasetId !== 0) {
                this.formJson.form_json.form_json.forEach(form => {
                    const onCreateEvents = this.formJson.form_json.events.filter(e => e.dataset_id === form.option.dataset_id
                        && e.eventName === eventName
                        && (eventData === undefined || (e.fromName === eventData.fromComponentName)));
                    if (onCreateEvents.length > 0) {
                        this.__completeTriggers(onCreateEvents[0].dataset_id, onCreateEvents[0].triggers, eventData);
                    }
                });
            } else {
                const onCreateEvents = this.formJson.form_json.events.filter(e => e.eventName === eventName
                    && (eventData === undefined || (e.fromName === eventData.fromComponentName)));
                if (onCreateEvents.length > 0) {
                    this.__completeTriggers(0, onCreateEvents[0].triggers, eventData);
                }
            }
        }
    }

    private _loadEventButton() {
        if (this.formJson.form_json.events !== undefined && this.formJson.form_json.events.length > 0) {
            const buttons = this.formJson.form_json.events.filter(x => (x.eventName === 'button1' || x.eventName === 'button2'
                || x.eventName === 'button3') && x.triggers.length > 0);

            buttons.forEach(b => {
                this.customButtons.push({buttonText: b.buttonText, eventName: b.eventName});
            });
        }
    }

    private _eventSetFormId(eventData: IEventData) {
        const formDataset = this.formJson.form_json.form_json.filter(x => x.option.dataset_id === eventData.datasetId);
        if (formDataset.length === 0) {
            return;
        }
        formDataset[0].rows.forEach(row => {
            row.cols.forEach(z => z.controls.forEach(control => {
                if (control.name === eventData.fromComponentName) {
                    formDataset[0].selectedRecordId = eventData.triggerValue;
                }
            }));
        });
    }

    private _eventSelectRow(eventData: IEventData) {
        const formDataset = this.formJson.form_json.form_json.filter(x => x.option.dataset_id === eventData.datasetId);
        if (formDataset.length > 0) {
            const rows = formDataset[0].rows.filter(c => c.header.create_or_select !== undefined && c.header.create_or_select !== ''
                && c.row !== eventData.fromComponentId);
            if (rows.length > 0) {
                rows.forEach(f => f.header.checked = false);
            }
        }
    }

    ngOnInit() {
        GlobalObjectService.register('setting', this.setting);
        GlobalObjectService.register('isFilter', this.isFilter);

        this.joinEvent();
        this.setUp();

    }

    joinEvent() {
        this.globalEventListenerService.eventLive.subscribe(ad => {
            if (ad !== null) {
                console.log('MAIN GLOBAL FORM', ad);
                console.log(this.formRecordData);
                if (ad) {
                    this.loadRecord(false, false, 1);
                }
            }
        });
    }

    setUp() {
        if (this.formJson) {

            if (this.formJson.form_json) {
                const masterForm = this.formJson.form_json.form_json.filter(x => x.option.form_type === 'master');
                if (masterForm.length > 0) {
                    this.masterDatasetId = masterForm[0].option.dataset_id || 0;
                }
                this._eventonTrigger(EventName.FormOnCreate);
                this._loadEventButton();
                GlobalObjectService.register('action_data_' + this.FORM_ID.toString(), this.actionPassedData, true);
                if (this.actionPassedData !== undefined && this.actionPassedData !== null) {
                    GlobalObjectService.register('shadow_' + this.FORM_ID.toString(), this.actionPassedData.shadowFieldValues, true);
                }
                FormLoader.loadActionData(this.formJson, this.actionPassedData);

            }
            this.loadRecord();
        }
    }

    public refreshAll() {
        // this.eventListenerService.updateLiveView(true);
        console.log('----------', this.formJson);
        this.loadRecord(true);
    }

    loadRecord(isReload = false, isRecreate = true, subEventStatus = 0) {
        if (this.formJson === null) {
            return;
        }
        console.log('--->this.formJson.form_name:', this.formJson);
        this.titlePass.emit(this.formJson.form_name || '');
        this.isView = this.formJson.designer_type === 'DASHBOARD';
        console.log('--->this.formJson.form_name:', this.formJson.form_name || '');
        if (!this.RECORD_ID || this.RECORD_ID === 0 || (this.actionFlag === ActionFlag.NEW && this.formJson.designer_type === 'FORM')) {
            this.loadComponent();
            this.formIsLoading = false;
            this.loadingIsDone = true;


            if (this.outData !== null && this.outData !== undefined && this.outData.form_data !== null
                && this.outData.form_data !== undefined) {
                FormLoader.loadFormOutData(this.formJson, this.formFieldStructure, this.outData.form_data);
            }

            return;
        }
        this.formIsLoading = true;
        this.loadingIsDone = false;

        this.datasetService.getDatasetRecord(this.setting, this.masterDatasetId, this.RECORD_ID, this.formJson.designer_type)
            .subscribe(response => {
                if (response.complete) {

                    if (this.formJson.designer_type === 'VIEW') {
                        this.formFieldStructure = response.fields;
                        this.formRecordData = response.data;
                        this.showButtonSave = false;
                        this.isView = true;


                        GlobalObjectService.register('formFieldStructure_' + this.FORM_ID.toString(), this.formFieldStructure, true);
                        GlobalObjectService.register('formRecordData_' + this.FORM_ID.toString(), this.formRecordData, true);
                        GlobalObjectService.register('record_id_' + this.FORM_ID.toString(), this.RECORD_ID, true);
                        GlobalObjectService.register('pkeys_' + this.FORM_ID.toString(), response.pkeys, true);


                        this.itFormLoaded$.emit(response);

                        if (subEventStatus > 0) {
                            /*
                            Bu etkileşim ile yeniden yüklenen verinin alt viewler tarafından tekrar kullanılması için çağrı oluşturulur.
                             */
                            this.globalEventListenerService.updateSubView(subEventStatus);
                        }

                    } else {
                        FormLoader.loadFormFromRemoteData(this.formJson, response.fields, response.data, this.actionPassedData);
                    }

                    if (isRecreate) {
                        this.loadComponent();
                        this.cd.detectChanges();
                    }
                    if (!isReload) {
                        this._eventonTrigger(EventName.FormAfterLoad);
                    }

                } else {
                    alert('Form verileri yüklenemedi. E.003');
                }

                this.formIsLoading = false;
                this.loadingIsDone = true;


            }, error1 => {
                alert('Form verileri yüklenemedi.' + error1);
                this.formIsLoading = false;
                this.loadingIsDone = true;
            });
    }

    loadComponent() {
        const containerName = 'View' + this.formJson.designer_type + this.formJson.form_view_type_id;
        console.log('containerName:', containerName);
        const component = this.noosFormTypeFactory.getPostTypeFromString(containerName);
        if (component === null || component === undefined) {
            return;
        }
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        this.formContainer.clear();
        const componentRef = this.formContainer.createComponent(componentFactory);
        (componentRef.instance as IViewComponent).formJson = this.formJson.form_json.form_json;
        (componentRef.instance as IViewComponent).isFilter = this.isFilter;
        (componentRef.instance as IViewComponent).showLoader = this.showLoader;
        (componentRef.instance as IViewComponent).datasetId = this.masterDatasetId;
        (componentRef.instance as IViewComponent).formId = this.FORM_ID;
        (componentRef.instance as IViewComponent).keyOnEnter.subscribe(ret => {
            this.onSaveForm();
        });
        if (this.formJson.form_view_type_id === 'wizard') {
            this.currentFormInstance = componentRef.instance;
            (componentRef.instance as IViewStepperComponent).changeStep.subscribe((ret: IWizardViewOutput) => {
                this.showButtonSave = ret.currentStep === ret.totalStep;
                this.showButtonNext = ret.currentStep < ret.totalStep;
                this.showButtonPrev = ret.currentStep > 1;
            });
        }
        if (this.formJson.designer_type === 'VIEW') {
            (componentRef.instance as IViewComponent).formFieldStructure = this.formFieldStructure;
            (componentRef.instance as IViewComponent).formRecordData = this.formRecordData;
        }
        componentRef.changeDetectorRef.detectChanges();
    }

    onSaveForm() {
        this.isSaving = true;
        const saver = new FormSaver(this.formJson, this.workFlowObjectId, this.fileControlResult, this.actionPassedData);
        if (!this.isFilter) {
            const validateResponse = saver.validate();
            if (!validateResponse.validation_status) {
                this.openControlForm(validateResponse.validation_errors);
                this.isSaving = false;
                return;
            }
        }
        const formData: IFormSavingData = saver.generateSubmitData();
        if (this.outData !== undefined && this.outData !== null) {
            formData.out_data = this.outData;
        }
        const postData: IFormSaveStructure = {
            data: formData,
            FORM_ID: this.FORM_ID,
            RECORD_ID: this.RECORD_ID,
            FORM_GUID: this.FORM_GUID,
            masterDatasetId: this.masterDatasetId,
            flag: this.actionFlag,
            rid: this.RECORD_ID || 0
        };


        const emitData: IFormSaveEmit = {
            formSavingData: formData,
            justRecordMe: this.justRecordMe
        };
        console.log(this.triggerSave && !this.isFilter && !this.isTest);
        console.log(this.triggerSave, this.isFilter, this.isTest);
        if (this.triggerSave && !this.isFilter && !this.isTest) {
            this.formService.formSave(this.FORM_ID, postData).subscribe(response => {
                if (response.complete) {
                    formData.return_id = response.mdid;
                    this.isSaving = false;
                    if (this.isDialog) {
                        this.dialogRef.close(formData);
                    } else {
                        this.saveForm.emit(emitData);
                    }

                    if (response.trigger_form && response.trigger_form_id !== undefined && response.trigger_form_id !== 0) {
                        // Yeni bir form açılacak

                        const dialogData: IFormDialogData = {
                            setting: this.setting,
                            formId: response.trigger_form_id,
                            formJson: null,
                            actionFlag: response.trigger_record === undefined || response.trigger_record === 0
                                ? ActionFlag.NEW : ActionFlag.EDIT,
                            API_URLS: null,
                            workFlowObjectId: '',
                            actionPassedData: this.actionPassedData,
                            recordId: response.trigger_record,
                            triggerData: response.transfer_data
                        };


                        this.openNewForm(dialogData);

                    } else if (response.redirect_link && response.redirect_url !== '') {
                        location.href = response.redirect_url;
                    }

                } else {
                    this.isSaving = false;
                    alert(response.error_message);
                }
            }, error1 => {
                this.isSaving = false;
                console.error('f.c.247:', error1);
            });
        } else {
            this.isSaving = false;
            if (this.isDialog) {
                this.dialogRef.close(formData);
            } else {
                this.saveForm.emit(emitData);
            }
        }
    }

    openControlForm(errors: IFormValidationError[]) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '650px';
        dialogConfig.panelClass = 'formDialog';
        dialogConfig.data = errors;
        this.dialog.open(DialogFormErrorComponent, dialogConfig);
    }

    openNewForm(dialogData: IFormDialogData) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '650px';
        dialogConfig.panelClass = 'formDialog';
        dialogConfig.data = dialogData;

        this.dialog.open(FormComponent, dialogConfig);
    }

    onNext() {
        (this.currentFormInstance as IViewStepperComponent).onNext();
    }

    onPrev() {
        (this.currentFormInstance as IViewStepperComponent).onPrev();
    }

    onClose() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    fileUploadSave($event: IFormFileItem[]) {
        this.fileData = $event;
    }

    onFileControl($event: boolean) {
        this.fileControlResult = $event;
    }

    ngOnChanges(changes: any): void {
        this.formContainer.clear();
        this.fileData = [];
        this.masterDatasetId = 0;
        this.showButtonSave = true;
        this.showButtonNext = false;
        this.showButtonPrev = false;
        this.currentFormInstance = null;
        this.formIsLoading = true;
        this.loadingIsDone = false;
        this.error = null;
        this.fileControlResult = true;
        this.isSaving = false;
        this.triggerSave = false;
        this.justRecordMe = false;
        GlobalObjectService.register('setting', this.setting);
        this._createUpForm();
        this.cd.detectChanges();
    }

    public _createUpForm() {
        GlobalObjectService.register('setting', this.setting);
        if (this.FORM_ID !== null && this.FORM_ID !== undefined && this.FORM_ID > 0 && this.setting !== null) {

            const formKey = 'FORM__' + this.FORM_ID;
            const formStructureSavedData = this.localdb.getObject(formKey, null);
            // console.log('formStructureSavedData:', formStructureSavedData);
            if (formStructureSavedData) {
                console.log('FORM2->IN-->formService.formStructureSavedData //');
                this.executeFormStructure(JSON.parse(JSON.stringify(formStructureSavedData)));
                this.cd.detectChanges();
            } else {
                this.formService.formStructure(this.FORM_ID).subscribe(ret => {
                    console.log('FORM2->IN-->formService.formStructure**');
                    if (ret.complete) {
                        this.localdb.setObject(formKey, ret.data);
                        this.executeFormStructure(ret.data);
                    }
                }, error1 => {
                    this.loadingIsDone = true;
                    this.error = 'Form oluşturulurken bir hata oldu. Lütfen sistem yöneticinize başvurun!</br>' + error1;
                });
            }
        }
    }

    private executeFormStructure(data: any) {
        this.formJson = data;
        if (this.formJson.designer_type === 'BOMFORM') {
            this.formJson.designer_type = 'FORM';
        }
        this.formIsLoading = false;
        this.triggerSave = data.trigger_save;
        this.setUp();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.subscription2.unsubscribe();
        this.globalSubscription.unsubscribe();
        // this.globalSubscription2.unsubscribe();
    }

    onCustomClick(eventName: string) {
        this._eventonTrigger(eventName as EventName);
    }
}
